<template>
  <div>
    <!-- 通用底部 -->
    <footer class="footer" id="footer">
      <div class="footer-content">

        <div class="footer-content-top">
          <div class="footer-content-top-left">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <img src="~/assets/logo.svg" alt="">
              <span style="font-family: 'PangMenZhengDao-3'; font-size: 26px; margin-top: 10px;">易趣软件</span>
            </div>
            <span>· 简单可依靠 ·</span>
          </div>

          <div class="footer-content-top-middle">
            <div class="footer-content-top-middle-product">
              <p class="top-title">产品</p>
              <p><a href="/softs/batchrename" target="_blank">易趣批量重命名</a></p>
              <p><a href="/softs/audioconverter" target="_blank">易趣音频格式转换器</a></p>
              <p><a href="/softs/ofdconverter" target="_blank">易趣OFD转换器</a></p>
            </div>
            <div class="contact-us">
              <p class="top-title">联系我们</p>
              <p class="item-link"><a href="mailto:esofttech@163.com">esofttech@163.com</a></p>
              <p class="item-link">软件交流群：1076462304
                <a class="item-linkqq-btn" href="http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=LCjAHCMQmsdrSW-80K239B_yobscAcOB&authKey=S4UjZaLLCJFTnTsSXedSBaOrNPNni0vrDMVfLOe7LN%2F2HbZB%2BA3niFoJS7Nu9Hky&noverify=0&group_code=1076462304" target="_blank">
                  <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuNDgzIDYuNzYyNTVDMTEuNTU4NyA1LjAzOTcyIDEwLjExODkgMy42OTIyNiA4LjQzNjQgMy42OTIyNkM2Ljc1Mzg2IDMuNjkyMjYgNS4yOTMzOCA1LjA1MTI4IDUuMzg5NzcgNi43NjI1NUM1LjQwODg5IDcuMTA2NTQgNS43MjgxNSA4LjgwOTU1IDUuNzI4MTUgOC44MDk1NUM1Ljk5MTY5IDEwLjI4NzkgNi45NDA5NSAxMS41MzgzIDguNDM2NCAxMS41MzgzQzkuOTMyMjcgMTEuNTM4MyAxMC44NjI0IDEwLjMwNjkgMTEuMTQ0MyA4LjgwOTU1QzExLjE0NDMgOC44MDk1NSAxMS40NjggNy4xMDY5NSAxMS40ODMgNi43NjI1NVoiIHN0cm9rZT0iI0M2QzZDNiIvPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45NDggMTkuMzg0NUgwLjkyMzA5NkwxLjE3NzI5IDE2LjQyMTVDMS4zMTYzOCAxNS4yOTM4IDIuNDI1NDcgMTQuNTE5NSAzLjU3MTk3IDE0LjI5MzJDMy41NzE5NyAxNC4yOTMyIDUuOTc1NjcgMTMuNjM3MiA4LjQzNTM2IDEzLjY0MTFDMTAuODk1MSAxMy42NDUxIDEzLjM1MTIgMTQuMzA4OSAxMy4zNTEyIDE0LjMwODlDMTQuNjI0NiAxNC41Mzg1IDE1LjY5NzUgMTUuMjU0MSAxNS43ODAxIDE2LjU1NzRMMTUuOTQ4IDE5LjM4NDVaIiBzdHJva2U9IiNDNkM2QzYiLz4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuNDE0NCA4LjgwMDQ5QzE5LjQ3NDYgNy40NDAyMyAxOC4zMjMyIDYuMzc2NDYgMTYuOTc3IDYuMzc2NDZDMTUuNjMwOCA2LjM3NjQ2IDE0LjQ2MjcgNy40NDkzMSAxNC41Mzk2IDguODAwNDlDMTQuNTU1MSA5LjA3MjIxIDE0LjgxMDUgMTAuNDE2NCAxNC44MTA1IDEwLjQxNjRDMTUuMDIxMSAxMS41ODM0IDE1Ljc4MDUgMTIuNTcwNyAxNi45NzcgMTIuNTcwN0MxOC4xNzM1IDEyLjU3MDcgMTguOTE3OCAxMS41OTgyIDE5LjE0MzUgMTAuNDE2NEMxOS4xNDM1IDEwLjQxNjQgMTkuNDAyMiA5LjA3MjIxIDE5LjQxNDQgOC44MDA0OVoiIHN0cm9rZT0iI0M2QzZDNiIvPg0KPHBhdGggZD0iTTE2Ljk3NjQgMTQuNDI5MkwyMC45OTMgMTQuOTE5OEMyMS45NjgzIDE1LjA5NzQgMjIuODU5OCAxNS42NzMgMjIuOTM4NyAxNi43MjQ0TDIzLjA3NyAxOS4zODQ2SDE4LjM5OTkiIHN0cm9rZT0iI0M2QzZDNiIvPg0KPC9zdmc+DQo=" alt="">
                  加入QQ群
                </a>
              </p>
            </div>
          </div>

          <div style="width: 0px;"></div>

          <div class="footer-content-top-right">
            <div class="about-us-box">
              <p class="top-title">关注我们</p>
              <div class="wx-box">
                <div class="wx-account qrcode">
                  <span>微信公众号</span>
                  <img src="/images/wx_qrcode.jpg" alt="">
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="footer-content-bottom">
          <ul class="footer-content-bottom-left">
            <li><a href="/agreements/legaldisclaimer">法律声明</a></li>
            <li><a href="/agreements/privacypolicy">隐私政策</a></li>
            <li><a href="/agreements/useragreement">用户协议</a></li>
            <li><a href="/agreements/disclaimer">免责声明</a></li>
            <li><a href="/agreements/CookiesPolicy">Cookies策略</a></li>
            <!-- <li class="disabled"><a href="/sitemap.xml">站点地图</a></li> -->
          </ul>
          <div class="footer-content-bottom-right">
            <span>{{sz公司名}}版权所有 © {{iYEAR}}&nbsp;</span>
            <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" rel="nofollow">{{szICP备案}}</a>
          </div>
        </div>

      </div>
    </footer>

  </div>
</template>

<script lang="ts" setup>
import * as Vue from 'vue'
import * as VueUse from '@vueuse/core'

import {
  ElCollapse, ElCollapseItem,
  ElLink
} from 'element-plus'


const iYEAR = Vue.computed(() => new Date().getFullYear())

const sz公司名 = '易软信息科技（惠州）有限公司'
const szICP备案 = '粤ICP备2025464331号'
const sz公网安备 = '粤公网安备44133002100261'

/* 屏幕 >= 820px时，条款项不使用el-collapse折叠面板 */
/*   底部的条款项，在窄屏下，使用el-collapse折叠面板来展示 */
const bShowLargeFooter = VueUse.useMediaQuery('(min-width: 820px)')
</script>

<style scoped>
li {
  list-style-type: none;
}
.footer {
  white-space: nowrap;
  display: flex;
  width: 100%;
  background: rgb(31, 31, 36);
  box-sizing: border-box;
  position: relative;
  padding-top: 40px;

  color: #FFF;
  font-family: "Microsoft YaHei";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.footer-content {
  display: flex;
  flex-direction: column;
  width: 1200px;
  margin: 0 auto;
}

.footer-content-top {
  display: flex;
  padding-bottom: 40px;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1015);

  .top-title {
    font-size: 18px;
    font-weight: 700;
  }

  .footer-content-top-left {
    display: flex;
    flex-direction: column;
    gap: 12px;

    img {
      width: 80px;
      height: 80px;
      flex-shrink: 0;
    }

    span {
      color: #F4F4F4;
      text-align: center;
    }
  }

  .footer-content-top-middle {
    display: flex;
    gap: 145px;

    .footer-content-top-middle-product {
      display: flex;
      flex-direction: column;
      gap: 12px;

      a {
        width: fit-content;
        color: #FFF;
        opacity: 0.45;
        font-size: 16px;
        font-weight: 400;
      }
    }

    .contact-us {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .item-link {
        color: #FFF;
        opacity: 0.45;
        font-size: 16px;
        font-weight: 400;

        a {
          color: #FFF;
        }
      }

      .item-linkqq-btn {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        border: 1px solid rgba(255, 255, 255, .2);

        border-radius: 4px;
        cursor: pointer;
        padding: 0 5px;
        margin-left: 10px;
        margin-bottom: 0;

        img {
          border: 0;
          vertical-align: middle;
        }
      }
    }
  }

  .footer-content-top-right {
    .about-us-box {
      .wx-box {
        display: flex;
        align-items: center;
        gap: 40px;
        margin-top: 12px;

        .qrcode {
          display: flex;
          flex-direction: column;
          gap: 12px;

          span {
            opacity: 0.45;
          }

          img {
            width: 112px;
            height: 112px;
            border-radius: 4px;
          }
        }
      }

    }
  }

}

.footer-content-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-bottom: 27px;

  .footer-content-bottom-left {
    display: flex;
    gap: 40px;

    a {
      color: #FFF;
      opacity: 0.3025;
      text-align: center;
    }
  }

  .footer-content-bottom-right {
    color: #FFF;
    opacity: 0.45;
    text-align: center;
    margin-left: 40px;

    a {
      color: #FFF;
      text-align: center;
    }
  }
}

.disabled {
  cursor: not-allowed;
  pointer-events: none;
}
</style>
